import { roleLabel } from "../superAdminRules";
import { Field } from "../SuperAdminCommon";
import {
    btnOutlineDangerStyle,
    btnOutlineStyle,
    cardStyle,
    cardTitleStyle,
    errorStyle,
    inputStyle,
    mutedTextStyle,
    tableStyle,
    tdStyle,
    thStyle,
} from "../superAdminStyles";
import { UserCreateForm, UserEditForm } from "./UserForms";

function UserRows({ user: u, users }) {
    const editing = users.editingUserId === u.id;
    return (
        <>
            <tr style={{ borderBottom: editing ? "none" : "1px solid #f3f4f6" }}>
                <td style={tdStyle}>{u.email}</td>
                <td style={tdStyle}>{roleLabel(u.role)}</td>
                <td style={{ ...tdStyle, display: "flex", gap: "6px" }}>
                    <button onClick={() => users.startEditUser(u)} style={btnOutlineStyle}>Modifier</button>
                    <button onClick={() => users.handleDeleteUser(u.id)} style={btnOutlineDangerStyle}>Supprimer</button>
                </td>
            </tr>
            {editing && (
                <tr style={{ borderBottom: "1px solid #f3f4f6" }}>
                    <td colSpan={3} style={{ padding: "12px 0 16px" }}>
                        <UserEditForm editor={users} />
                    </td>
                </tr>
            )}
        </>
    );
}

function UsersTable({ users }) {
    return (
        <table style={tableStyle}>
            <thead>
                <tr>{["Email", "Rôle", "Actions"].map(h => <th key={h} style={thStyle}>{h}</th>)}</tr>
            </thead>
            <tbody>
                {users.users.length === 0 && (
                    <tr><td colSpan={3} style={{ padding: "16px", textAlign: "center", color: "#9ca3af", fontSize: "14px" }}>Aucun utilisateur</td></tr>
                )}
                {users.users.map(u => <UserRows key={u.id} user={u} users={users} />)}
            </tbody>
        </table>
    );
}

function PharmacyUsers({ users }) {
    return (
        <>
            <UserCreateForm
                userForm={users.userForm}
                setUserForm={users.setUserForm}
                userSubmitting={users.userSubmitting}
                onSubmit={users.handleUserSubmit}
            />
            {users.userFormError && <p style={{ ...errorStyle, marginTop: "-12px", marginBottom: "16px" }}>{users.userFormError}</p>}

            {users.usersLoading && <p style={mutedTextStyle}>Chargement...</p>}
            {users.usersError && <p style={errorStyle}>{users.usersError}</p>}
            {!users.usersLoading && !users.usersError && <UsersTable users={users} />}
        </>
    );
}

export function UsersCard({ pharmacies, users }) {
    return (
        <div style={cardStyle}>
            <h2 style={{ ...cardTitleStyle, marginBottom: "20px" }}>Gestion des utilisateurs</h2>

            <div style={{ marginBottom: "20px" }}>
                <Field label="Pharmacie">
                    <select style={{ ...inputStyle, width: "280px" }} value={users.selectedPharmacyId} onChange={users.handlePharmacySelect}>
                        <option value="">— Sélectionner une pharmacie —</option>
                        {pharmacies.map(p => (
                            <option key={p.id} value={p.id}>{p.name}</option>
                        ))}
                    </select>
                </Field>
            </div>

            {users.selectedPharmacyId && <PharmacyUsers users={users} />}
        </div>
    );
}
